import { styled } from "goober";
import { useEffect, useRef, useState } from "react";
import { writeToClipboard } from "../lib/writeToClipboard";
import { AnimatedCopyIcon } from "./AnimatedCopyIcon";
import type { IconName } from "./Icon";
import { PressButton } from "./PressButton";
import { Tooltip } from "./Tooltip";

const Button = styled(PressButton)`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--alpha4);
  color: var(--text-primary);
  &:hover {
    background: var(--alpha8);
  }
`;

export function StepCopyButton({
  text,
  icon,
}: {
  text: string;
  icon: IconName;
}) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  useEffect(() => () => clearTimeout(timeoutRef.current), []);
  return (
    <Tooltip vertical="below" content={text}>
      <Button
        aria-label={`Copy ${text}`}
        onPress={() => {
          void writeToClipboard(text);
          setCopied(true);
          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => setCopied(false), 1500);
        }}
      >
        <AnimatedCopyIcon copied={copied} size={16} icon={icon} />
      </Button>
    </Tooltip>
  );
}
